"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppThemeProvider = AppThemeProvider;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _AppThemeContext = require("./AppThemeContext");
var _AppThemeProvider = require("./AppThemeProvider.types");
var _reactCookie = require("react-cookie");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function AppThemeProvider(_ref) {
  var children = _ref.children;
  var _useCookies = (0, _reactCookie.useCookies)([_AppThemeProvider.AppThemeItemName]),
    _useCookies2 = _slicedToArray(_useCookies, 2),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1];
  var _useState = (0, _react.useState)(function () {
      if (cookies[_AppThemeProvider.AppThemeItemName] === 'dark') {
        return 'dark';
      }
      return 'light';
    }),
    _useState2 = _slicedToArray(_useState, 2),
    mode = _useState2[0],
    setMode = _useState2[1];
  (0, _react.useEffect)(function () {
    var _a;
    setCookie(_AppThemeProvider.AppThemeItemName, mode, {
      secure: process.env.REACT_APP_COOKIE_SECURE === 'true',
      domain: (_a = process.env.REACT_APP_COOKIE_DOMAIN) !== null && _a !== void 0 ? _a : '/',
      path: '/'
    });
  }, [mode]);
  var theme = (0, _material.createTheme)({
    palette: {
      mode: mode,
      primary: {
        light: '#76c3f5',
        main: '#3f93c2',
        dark: '#006591',
        contrastText: '#fff'
      },
      secondary: {
        light: '#ffc777',
        main: '#f79648',
        dark: '#bf6718',
        contrastText: '#fff'
      },
      background: {
        "default": mode === 'light' ? '#f8f9fa' : undefined
      }
    },
    typography: {
      fontFamily: "'DM Sans', sans-serif",
      fontWeightLight: 400,
      fontWeightRegular: 500,
      fontWeightMedium: 500,
      fontWeightBold: 700,
      button: {
        textTransform: 'none'
      }
    }
  });
  var value = (0, _react.useMemo)(function () {
    return {
      current: mode,
      toggle: function toggle() {
        setMode(function (curr) {
          return curr === 'light' ? 'dark' : 'light';
        });
      }
    };
  }, [mode]);
  return /*#__PURE__*/_react["default"].createElement(_AppThemeContext.AppThemeContext.Provider, {
    value: value
  }, /*#__PURE__*/_react["default"].createElement(_material.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_material.CssBaseline, {
    enableColorScheme: true
  }), children));
}